import React, { useState } from 'react';
import styled from 'styled-components';

const BannerWrapper = styled.div`
  width: 100%;
  background-color: #00BCE2;
  color: #FFF;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8px 0;
  margin: 0 auto;
  grid-area: announcement;
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
`;

const Headline = styled.span`
  font-size: 16px;
  font-weight: bold;
`;

const BodyText = styled.span`
  font-size: 14px;
  font-weight: normal;
`;

const CloseButton = styled.button`
  position: absolute;
  color: #FFF;
  top: 8px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 32px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
`;

export default function AnnouncementBanner({ onClose }) {
  return (
    <BannerWrapper>
      <CloseButton aria-label="Close" onClick={onClose}>&times;</CloseButton>
      <BannerContent>
        <Headline>Cool News &mdash; Lower Shipping Rates</Headline>
        <BodyText>
          We negotiated lower rates & have passed along the savings to you!
        </BodyText>
      </BannerContent>
    </BannerWrapper>
  );
}
